import {
  Flex,
  Heading,
  useColorModeValue,
  Text,
  Box,
  Stack,
  Icon,
} from "@chakra-ui/react";
import React from "react";
import { MdLocalLaundryService } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { LaundretteOverview } from "../../data/laundrette.api";

type Props = {
  laundrette: LaundretteOverview;
};

const LaundretteCard = ({ laundrette }: Props) => {
  const navigate = useNavigate();
  const bg = useColorModeValue("gray.50", "gray.700");
  const secondaryBg = useColorModeValue("white", "gray.900");
  const hoverColour = useColorModeValue("gray.100", "gray.600");
  const iconColour = useColorModeValue("lancsBlue.400", "whiteAlpha.500");

  return (
    <Flex
      border="1px solid rgba(0, 0, 0, 0.1)"
      rounded="md"
      overflow="hidden"
      role="group"
      bg={bg}
      cursor="pointer"
      transition=".1s all"
      _hover={{ bg: hoverColour }}
      onClick={() => navigate(`/laundry/${laundrette.laundryroom.location}`)}
      p={5}
      direction="column"
    >
      <Heading size="sm" textTransform="capitalize">
        {laundrette.laundryroom.site.toLowerCase()}
      </Heading>
    </Flex>
  );
};

export default LaundretteCard;
